import toast from 'react-hot-toast';
import {authenticate} from './helper'

//validate login page username
export async function usernameValidate(values){
    const errors=usernameVerify({},values);

    if(values.username){
        //check user existence
        const {status}=await authenticate(values.username);
        if(status!==200){
            errors.exist=toast.error('User doesnot exists')
        }
    }
    return errors;
}

function passwordVerify(error = {}, values) {
    const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  
    if (!values.password) {
      error.password = 'Password required!';
    } else if (values.password.includes(' ')) {
      error.password = 'Invalid password!';
    } else if (values.password.length < 5) {
      error.password = 'Password must contain at least 5 characters!';
    } else if (!specialChars.test(values.password)) {
      error.password = 'Password must include a special character!';
    }
  
    return error;
  }

//validate login page reset
export async function resetValidate(values){
    const errors=passwordVerify({},values);
    if(values.Password!==values.confirmPassword){
        errors.exist=toast.error("Password not matched")
    }
    return errors;
}

//validate login page password
export async function PasswordValidate(values){
    const errors=passwordVerify({},values);
    return errors;
}

//validate profile page

export async function profileValidate(values){
    const errors=emailVerify({},values);
    return errors;

}



// Validate Register Form
export async function registerValidate(values) {
    const errors = usernameVerify({}, values);
    passwordVerify(errors, values);
    emailVerify(errors, values);
    return errors;
  }
  
  function usernameVerify(error = {}, values) {
    if (!values.username) {
      error.username = 'Username required!';
    } else if (values.username.includes(' ')) {
      error.username = 'Invalid username!';
    }
    return error;
  }
  
  
  
  function emailVerify(error = {}, values) {
    if (!values.email) {
      error.email = 'Email required!';
    } else if (values.email.includes(' ')) {
      error.email = 'Invalid email!';
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
    ) {
      error.email = 'Invalid email address!';
    }
  
    return error;
  }
  